import { Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {RootScopeService} from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { Router } from '@angular/router';


@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss']
})
export class SplashComponent implements OnInit {
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;
  constructor(private rootScopeService: RootScopeService, private router: Router) {
    this.getRootScopeData();
  }

  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
    this.rootScopeData.pageName = 'Splash';
    if(localStorage.getItem('splashVisited') === 'true' ){
      this.router.navigate(['/landing']);
    }
    localStorage.setItem('splashVisited', 'true');

    }
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

}
